module.exports = __webpack_public_path__ + "static/labelsYes-849399b6439e7e71b3c5c7ac01abd369.png";